import { useQuery } from '@tanstack/react-query'
import { ticketList } from '../index'

const useTicketList = (
  currentPage: number,
  limit: number,
  updateData?: boolean,
) => {
  return useQuery({
    queryKey: ['ticketList', currentPage, limit],
    queryFn: ticketList,
    enabled: !!currentPage && !!limit && !!updateData,
  })
}

export default useTicketList
